export default (palette, isDarkMode) => ({
  root: {
    borderRadius: '8px',
    textTransform: 'uppercase',
    fontWeight: 600,
    letterSpacing: '0.5px',
    transition: 'all 0.2s ease-in-out',
  },
  contained: {
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
})
